import CookiesJS from 'cookies-js';

export function initInitialRecommendations($, apiClient) {
    function extractRecommendations(field) {
        const items = [];
        $(`#${field} .array-item .array-item-value`).each(function () {
            items.push({
                text: $(this).val(),
            });
        });
        return items;
    }

    // Разделы собираются по блокам, а не по именам полей: блоков
    // в форме сорок пять, и уникальные `name` пришлось бы раздавать
    // вручную при каждом добавлении.
    function extractSections() {
        const sections = [];
        $('#sections .array-item').each(function () {
            const $item = $(this);
            const sex = $item.find('.section-sex').val();
            const section = {
                code: ($item.find('.section-code').val() || '').trim(),
                order: parseInt($item.find('.section-order').val(), 10) || 0,
                title: $item.find('.section-title').val(),
                navTitle: $item.find('.section-nav-title').val(),
                // Отступы в начале строк значения не имеют: разметка
                // разбирает абзац целиком. Срезаем их на сохранении,
                // чтобы вставленный откуда-нибудь текст не приносил
                // в базу лесенку из пробелов.
                body: ($item.find('.section-body').val() || '')
                    .split('\n').map(line => line.trim()).join('\n'),
                // bootstrap-select copies this class onto its wrapper div.
                // Read the select itself, otherwise .val() returns undefined
                // and an unchanged save removes every goal association.
                goalCodes: $item.find('select.section-goals').val() || [],
            };
            // Пустое «Кому» — раздел для всех; поле не отправляем вовсе,
            // чтобы не писать в базу число, которого человек не выбирал.
            if (sex === '0' || sex === '1') section.sex = parseInt(sex, 10);
            sections.push(section);
        });
        return sections;
    }

    $('form.initial-recommendations-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const body = {
                goals: $('#goals').val(),
                contraindications: $('#contraindications').val(),
                recommendations: extractRecommendations('recommendations'),
                sections: extractSections(),
                deleted: !!$('#deleted').prop('checked'),
            };

            if (!_id) {
                const result = await apiClient.create('/initial-recommendations', body, CookiesJS.get('auth_token'));
                console.log(result);
                document.location.href=`/initial-recommendations/edit/${result._id}`;
            } else {
                const result = await apiClient.updateOne('/initial-recommendations', _id, body, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch(e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
